import { useEffect, useState } from 'react'
import { getCountryCode } from 'helpers/getCountryCode'

const useGetCountryCode = (fallback = true) => {
  const [country, setCountry] = useState('')
  useEffect(() => {
    if (!country) {
      getCountryCode(fallback).then((res) => {
        setCountry(res)
      })
    }
  }, [fallback])

  return country
}

export default useGetCountryCode
